export default __webpack_public_path__ + "static/media/Ravenclaw Helm.d6dadc46.jpg";